import api from '../../lib/api';

export const FleetActionTypes = {
  FETCH_VEHICLES_SUCCESS: 'FETCH_VEHICLES_SUCCESS',
  FETCH_VEHICLES_FAILURE: 'FETCH_VEHICLES_FAILURE',
  SET_SELECTED_VEHICLE: 'SET_SELECTED_VEHICLE',
  VEHICLE_UPDATE_SUCCESS: 'VEHICLE_UPDATE_SUCCESS',
  VEHICLE_DELETED: 'VEHICLE_DELETED',
};

export const fetchVehicles = () => async (dispatch) => {
  try {
    const data = await api.fleet.getVehicles();
    dispatch({ type: FleetActionTypes.FETCH_VEHICLES_SUCCESS, payload: data });
    return { success: true };
  } catch {
    dispatch({ type: FleetActionTypes.FETCH_VEHICLES_FAILURE });
    return { success: false };
  }
};

export const setSelectedVehicle = (vehicle) => (dispatch) => {
  dispatch({ type: FleetActionTypes.SET_SELECTED_VEHICLE, payload: vehicle });
};

export const createVehicle = (input) => async (dispatch) => {
  try {
    const vehicle = await api.fleet.createVehicle(input);
    return { success: true, vehicle };
  } catch {
    return { success: false };
  }
};

export const updateVehicle = (vehicleId, input) => async (dispatch) => {
  try {
    const data = await api.fleet.updateVehicle(vehicleId, input);
    dispatch({ type: FleetActionTypes.VEHICLE_UPDATE_SUCCESS, payload: data });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const deleteVehicle = (vehicleId) => async (dispatch) => {
  try {
    await api.fleet.deleteVehicle(vehicleId);
    dispatch({ type: FleetActionTypes.VEHICLE_DELETED, payload: vehicleId });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const approveDriver = ({ userId, assignedBy }) => async () => {
  try {
    await api.fleet.approveDriver({ userId, assignedBy });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const revokeDriver = ({ userId }) => async () => {
  try {
    await api.fleet.revokeDriver({ userId });
    return { success: true };
  } catch {
    return { success: false };
  }
};

export const assignVehicleToTrip = (tripId, fleetVehicleId) => async () => {
  try {
    await api.fleet.assignVehicleToTrip(tripId, fleetVehicleId);
    return { success: true };
  } catch {
    return { success: false };
  }
};

// Surfaces the server message — attach fails for real reasons ops needs to see
// (unknown driver, trip not found, vehicle not operational).
export const attachFleetDriver = (input) => async () => {
  try {
    const data = await api.fleet.attachFleetDriver(input);
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.response?.data?.message };
  }
};

export const unassignVehicleFromTrip = (tripId, fleetVehicleId) => async () => {
  try {
    await api.fleet.unassignVehicleFromTrip(tripId, fleetVehicleId);
    return { success: true };
  } catch {
    return { success: false };
  }
};
